import { CdkScrollable } from '@angular/cdk/scrolling';
import { Component, inject } from '@angular/core';
import { MatButton } from '@angular/material/button';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogTitle
} from '@angular/material/dialog';
import { TranslatePipe } from '@ngx-translate/core';
import { FormNotFoundDialogData } from '../dialog-data.model';

@Component({
  selector: 'lfw-form-not-found-dialog',
  templateUrl: './form-not-found-dialog.component.html',
  styleUrls: ['./form-not-found-dialog.component.css'],
  imports: [MatDialogTitle, CdkScrollable, MatDialogContent, MatDialogActions, MatButton, MatDialogClose, TranslatePipe]
})
export class FormNotFoundDialogComponent {
  readonly data = inject<FormNotFoundDialogData>(MAT_DIALOG_DATA);
}
